import http from '@util/http';
import { administrative } from '../req';

export async function queryAnnouncementList(params) {
  return http.get(administrative.GET_ANNOUNCEMENT_LIST, params);
}

export async function queryAnnouncementInfo(params) {
  return http.get(administrative.GET_ANNOUNCEMENT_INFO, params);
}

export async function querySaveAnnouncement(params) {
  return http.post(administrative.SAVE_ANNOUNCEMENT, params);
}

export async function queryDeleteAnnouncement(params) {
  return http.get(administrative.DELETE_ANNOUNCEMENT, params);
}



// WEBPACK FOOTER //
// ./src/api/administrative/announcement.js